import type { ChatTool, ToolUseProps } from "../components/Chat/ChatTool";
import { ToolStatus } from "../components/Chat/ToolStatus";

function MemoryHeader({ toolUse, result, interrupted }: ToolUseProps) {
  const input = toolUse.input;
  const command =
    input && typeof input === "object" && !Array.isArray(input)
      ? (input as Record<string, unknown>).command
      : null;
  const [pendingText, doneText, failedText] =
    command === "view"
      ? ["Reading memory…", "Read memory", "Couldn’t read memory"]
      : ["Updating memory…", "Updated memory", "Couldn’t update memory"];
  const text = result?.isError ? failedText : result ? doneText : pendingText;
  return (
    <ToolStatus icon="brain" text={text} pending={!result && !interrupted} />
  );
}

export const memory: ChatTool = {
  name: "memory",
  Header: MemoryHeader,
  headerOnly: true,
};
